<div *ngIf="!(empty | async); else zeroState" class="donut">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="256"
    (clientSize)="svgSize.next($event)"
  >
    <svg class="inner" x="50%" y="50%">
      <path
        *ngFor="let path of arcPaths | async; let i = index"
        class="data shadow"
        [attr.d]="path"
      ></path>
      <path
        *ngFor="let path of arcPaths | async; let i = index"
        class="data arc"
        [ngClass]="'color-' + (i + 1)"
        [class.hovered]="(hoveredIndex | async) === i"
        [attr.d]="path"
      ></path>
      <path
        [class.clickable]="clickable | async"
        *ngFor="let path of hitAreaArcPaths | async; let i = index"
        [attr.d]="path"
        (mouseenter)="hoveredIndex.next(i)"
        (mouseleave)="hoveredIndex.next(null)"
        (click)="onClick.next(i)"
        fill="transparent"
      ></path>
    </svg>
  </svg>
  <div class="legend">
    <div
      *ngFor="let point of dataPoints | async; let i = index"
      class="row"
      [class.clickable]="clickable | async"
      [class.hovered]="(hoveredIndex | async) === i"
      (mouseenter)="hoveredIndex.next(i)"
      (mouseleave)="hoveredIndex.next(null)"
      (click)="onClick.next(i)"
    >
      <span
        class="symbol"
        [class.clickable]="clickable | async"
        [ngClass]="'color-' + (i + 1)"
      ></span>
      <span class="label" [class.clickable]="clickable | async" truncate>
        {{ point.label }}
      </span>
      <span class="value" [class.clickable]="clickable | async">
        {{ (valueFormatter | async)!(point.value) }}
      </span>
    </div>
  </div>
</div>

<ng-template #zeroState>
  <div class="zero-state">No data to display.</div>
</ng-template>
